import { apiRequest } from './apiClient';

export function loginRequest({ username, password }) {
  return apiRequest('/auth/login', {
    method: 'POST',
    body: { username, password },
  });
}


